import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { TransportType } from '../transport-type';
import { TravelType } from '../travel-type';

@Component({
  selector: 'app-travel-create',
  templateUrl: './travel-create.component.html',
  styleUrls: ['./travel-create.component.css']
})
export class TravelCreateComponent implements OnInit {

  travelTypeForm!: FormGroup;
  types: TransportType[] = [];

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.travelTypeForm = this.builder.group({
      code: "",
      type: [null, Validators.required],
      description: "",
      billingNote: "",
      comment: ""
    });

    this.httpService.getTransportTypes().subscribe(res => {
      this.types = res;
    });
  }

  sendTravelType(){
    if(this.travelTypeForm.invalid){
      return;
    }
    this.httpService.postTravelType(
      new TravelType(
        null, 
        this.travelTypeForm.value.code,
        this.travelTypeForm.value.type,
        this.travelTypeForm.value.description,
        this.travelTypeForm.value.billingNote,
        this.travelTypeForm.value.comment,
        true
        )
    ).subscribe(() => {
      console.log("success");
    });
  }

}
